import moment from 'moment'

export default {
    async loadProposalsList(context, filter = null){
        let body = {
            "type": "jobs_list_full",
        }
        Object.assign(body, filter);

        return await this.$api.info.allApi(body)
        .then( (response) => {
            context.commit("proposals_list",response)
            return true
        })
    },
    async loadCurrentProposal(context, id){
        let body = {
            "type": "jobs_list_full",
            "id": id
        }
        return await this.$api.info.allApi(body)
        .then( (response) => {
            if(response && response.response && response.response.mansioni && response.response.mansioni.length)
                context.commit("current_proposal",response.response.mansioni[0])
            return true
        })
    },
    async jobsApply(context, par){
        let body = {
            type: "jobs_apply",
            autoCandidata: true,
            richiestaDisponibilita: true,
            mansione: par.body_candidatura.mansione_id,
            disponibilita: par.body_candidatura.disponibilita
        }
        
        return await this.$api.info.allApi(body)
        .then( async (response) => {
            let candidatura_id = response.response.id

            let body_disponibilita = {
                type: "availability_create",
                disponibilita: []
            }

            par.turns.forEach(turn => {
                body_disponibilita.disponibilita.push({
                    candidatura: candidatura_id,
                    turno: turn.id,
                    conferma_turno: 1,
                    disponibilita_turno: moment(turn.data.dataInizio).isBefore(moment()) ? 0 : 1,
                    
                })
            });

            await this.$api.info.allApi(body_disponibilita)
            .then( async () => {
                let edit_body = {
                    "type": "job_edit",
                    "autoCandidata": true,
                    "id": candidatura_id,
                    step: 2,
                }
                return await this.$api.info.allApi(edit_body)
                .then( () => {
                    return true
                })
            })

            return candidatura_id

           
        })
    },
}
